import { PlaylistAssignmentsProgressContainer, getTotalProgressFromItemsProgress } from '..';
import UIProgress from 'UIComponents/progress/UIProgress';
import I18n from 'I18n';
import UIFlex from 'UIComponents/layout/UIFlex';
import { UserLink, UserLinkWithExternalIcon } from '../../users';
import { AvatarViewer } from '../../avatar';
import formatName from 'I18n/utils/formatName';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PlaylistAssignmentProgress = ({
  assignment: {
    assignee: {
      firstName,
      lastName,
      userId,
      avatarHash
    },
    portalId,
    progress
  }
}) => {
  const displayName = formatName({
    firstName,
    lastName
  });
  const {
    itemsProgress
  } = progress || {
    itemsProgress: []
  };
  const progressPercentage = useMemo(() => getTotalProgressFromItemsProgress(itemsProgress), [itemsProgress]);
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    gap: 24,
    children: [/*#__PURE__*/_jsx(UserLink, {
      portalId: portalId,
      userId: userId,
      children: /*#__PURE__*/_jsx(AvatarViewer, {
        avatarHash: avatarHash,
        displayName: displayName,
        size: "md",
        type: "contact"
      })
    }), /*#__PURE__*/_jsxs(PlaylistAssignmentsProgressContainer, {
      children: [/*#__PURE__*/_jsx(UserLinkWithExternalIcon, {
        external: true,
        portalId: portalId,
        userId: userId,
        children: displayName
      }), /*#__PURE__*/_jsx(UIProgress, {
        "aria-label": I18n.text('learningCenter.playlistAssignments.assignmentProgress', {
          progressPercentage: I18n.formatPercentage(progressPercentage)
        }),
        use: "success",
        value: progressPercentage
      })]
    })]
  });
};
export default PlaylistAssignmentProgress;